/**
 * DCMS FRONTEND API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CommunicationContentStateEnum } from './communicationContentStateEnum';
import { RecipientDelivery } from './recipientDelivery';


/**
 * The content of an email: ``pending`` until the WebSocket says ``communication.content_ready``.
 */
import {ValidatorFn, Validators} from "@angular/forms";

export interface CommunicationContent { 
    state: CommunicationContentStateEnum;
    subject?: string;
    html?: string;
    text?: string;
    recipients?: Array<RecipientDelivery>;
}
export namespace CommunicationContent {
}

export const CommunicationContent_state_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const CommunicationContent_subject_Validators: ValidatorFn[] =
    [ ];

export const CommunicationContent_html_Validators: ValidatorFn[] =
    [ ];

export const CommunicationContent_text_Validators: ValidatorFn[] =
    [ ];

export const CommunicationContent_recipients_Validators: ValidatorFn[] =
    [ ];


